export default "__VITE_ASSET__c37d9a2a__"